var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-action-wrapper overflow-initial"},[_c('div',{staticClass:"cell-content actions"},[_c('ActionsMenu',{attrs:{"actions":_vm.actions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }